import { QueryClient, type QueryKey } from '@tanstack/react-query';
import { processResponse, Queries } from '../query-client';
import type { WidgetConfig } from '../../store/widget.store';

function GetWidgets() {
    return fetch(`/api/admin/widget`, {
        method: 'get',
    }).then(processResponse<WidgetConfig[]>);
}

function GetWidgetById({ queryKey }: { queryKey: QueryKey }) {
    const [, id] = queryKey;
    return fetch(`/api/admin/widget/${id}`, {
        method: 'get',
    }).then(processResponse<WidgetConfig>);
}

export function addWidgetQueries(queryClient: QueryClient) {
    queryClient.setQueryDefaults([Queries.WIDGET_GET_ALL], {
        queryFn: GetWidgets,
    });
    queryClient.setQueryDefaults([Queries.WIDGET_GET_BY_ID], {
        queryFn: GetWidgetById,
    });
}
